<template>
  <section class="Grid-layout footer-static-links">
    <nav class="footer-static-links__nav">
      <ux-molecules-accordion
        :has-arial-label-by="false"
        :has-role="false"
        :is-collapsable="!isDesktop"
        :key="index"
        :title="rt(section.label)"
        @is-hidden="(value: boolean) => handleAriaHidden(index, value)"
        class="footer-static-links__accordion"
        v-for="(section, index) in footerLinks"
        variant="footer-links"
      >
        <template #content>
          <ul :aria-hidden="ariaHidden[index]" class="footer-static-links__accordion-container">
            <li :key="rt(element.label)" class="footer-static-links__accordion-container__item" v-for="element in section?.elements">
              <ux-atoms-link
                :classic="false"
                :target="isExternalURL(context, rt(element.url)) ? '_blank' : '_self'"
                :text="rt(element.label)"
                :to="rt(element.url)"
              />
            </li>
          </ul>
        </template>
      </ux-molecules-accordion>
    </nav>
  </section>
</template>
<script setup lang="ts">
import { useSSRContext } from 'vue';

import { isExternalURL } from '~/helpers/url';

interface FooterLinkElement {
  label: string;
  url: string;
}

interface FooterLinkSection {
  elements: FooterLinkElement[];
  label: string;
}

let context: Record<string, unknown> | undefined;

const { rt, tm } = useI18n({
  useScope: 'global'
});
const { isDesktop } = useScreen();
const desktopFooter = ref<Boolean>(false);

if (process.server) {
  context = useSSRContext();
}

const footerLinks = tm('ux.molecules.footerStaticLinks') as FooterLinkSection[];

const ariaHidden = ref(Object.keys(footerLinks).map(() => false));

const handleAriaHidden = (index: number, value: boolean) => {
  ariaHidden.value[index] = value;
};

watch(isDesktop, () => {
  desktopFooter.value = isDesktop.value as boolean;
});
</script>
<style lang="scss" scoped>
@use 'FooterStaticLinks.scss';
</style>
